var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectrical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 38.03,
    y: 2.5,
    className: "st1",
    width: 1.95,
    height: 9.76
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.73,26.64c0,2.05-1.67,3.72-3.73,3.72c-2.05,0-3.72-1.67-3.72-3.72H42.73z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000038408291152257909890000007286631350634316454_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.3,15.68h-8.57c-3.72,2.14-6.23,6.14-6.23,10.74h21.01C49.51,21.82,47.01,17.82,43.3,15.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.51,26.91H28.5c-0.27,0-0.49-0.22-0.49-0.49c0-4.59,2.48-8.87,6.48-11.16c0.07-0.04,0.16-0.06,0.24-0.06 h8.57c0.09,0,0.17,0.02,0.24,0.07c3.98,2.3,6.46,6.57,6.46,11.16C50,26.69,49.78,26.91,49.51,26.91z M29,25.93h20.01 c-0.17-4.01-2.37-7.71-5.85-9.76h-8.3C31.38,18.22,29.17,21.92,29,25.93z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000161590364058353539850000004578614408764086449_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.61,
    y: 12.26,
    className: "st0",
    width: 8.79,
    height: 3.42
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.4,16.17h-8.79c-0.27,0-0.49-0.22-0.49-0.49v-3.42c0-0.27,0.22-0.49,0.49-0.49h8.79 c0.27,0,0.49,0.22,0.49,0.49v3.42C43.89,15.95,43.67,16.17,43.4,16.17z M35.1,15.19h7.81v-2.44H35.1V15.19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000070084635616816511180000009413233962292344969_"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "16.28,3.48 16.28,23 13.35,23 13.35,3.48  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000085949977214513187450000006983334623336794293_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.75,42.58c0,2.72-2.22,4.92-4.94,4.92c-2.72,0-4.94-2.2-4.94-4.92"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000119832150749579267870000001177866935572948658_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.67,28.37H8.99c-5.07,2.92-8.5,8.37-8.5,14.65h28.65C29.14,36.74,25.72,31.29,20.67,28.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.14,43.51H0.49C0.22,43.51,0,43.29,0,43.02c0-6.19,3.35-11.97,8.74-15.07c0.07-0.04,0.16-0.06,0.24-0.06 h11.68c0.09,0,0.17,0.02,0.24,0.07c5.38,3.1,8.72,8.87,8.72,15.07C29.63,43.29,29.41,43.51,29.14,43.51z M0.98,42.53h27.66 c-0.17-5.62-3.24-10.81-8.11-13.67H9.12C4.23,31.72,1.15,36.91,0.98,42.53z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_00000077289360624268351720000010492775761470909614_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.95,
    y: 23,
    className: "st0",
    width: 11.72,
    height: 5.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.67,28.86H8.95c-0.27,0-0.49-0.22-0.49-0.49V23c0-0.27,0.22-0.49,0.49-0.49h11.72 c0.27,0,0.49,0.22,0.49,0.49v5.37C21.16,28.64,20.94,28.86,20.67,28.86z M9.44,27.88h10.74v-4.39H9.44V27.88z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectrical);
export default __webpack_public_path__ + "static/media/electrical.889897de448a019c8329c4b7da20a5c1.svg";
export { ForwardRef as ReactComponent };